import {Mapper} from '@s-ui/domain'

export class SeoAdsListSemanticMaxPriceMetaConfigMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Object} deps.log
   * */
  constructor({config}) {
    super()
    this._config = config
    this._seoConfig = this._config.get('seo')
  }

  _getAdsListSemanticConfigKey = ({maxPrice, province, bodyType, fuelType}) => {
    const hasMaxPrice = Boolean(maxPrice)
    const hasProvince = Boolean(province)
    const hasBodyType = Boolean(bodyType)
    const hasFuelType = Boolean(fuelType)

    // These are the four combination of SEO Metadata typologies
    // for price ads-list pages [/1000-euros/]
    const isDefault = hasMaxPrice && !hasProvince && !hasBodyType && !hasFuelType
    const isProvince = hasMaxPrice && hasProvince && !hasBodyType && !hasFuelType
    const isBodyType = hasMaxPrice && !hasProvince && hasBodyType && !hasFuelType
    const isFuelType = hasMaxPrice && !hasProvince && !hasBodyType && hasFuelType

    switch (true) {
      case isDefault:
        return 'default'
      case isProvince:
        return 'province'
      case isBodyType:
        return 'bodyType'
      case isFuelType:
        return 'fuelType'
      default:
        return 'default'
    }
  }

  map = ({adsListSemanticConfig, params: {maxPrice, province, bodyType, fuelType}}) => {
    const adsListSemanticConfigKey = this._getAdsListSemanticConfigKey({
      maxPrice,
      province,
      bodyType,
      fuelType
    })

    return adsListSemanticConfig[adsListSemanticConfigKey] || adsListSemanticConfig.default
  }
}
